import firebase from 'firebase/app'
import 'firebase/firestore'
import 'firebase/storage'

function fetchErrors () {
  const database = firebase.firestore()
  return database.collection('exceptions').get()
    .then(res => {
      const exceptions = []
      res.forEach(exception => {
        exceptions.push({...exception.data(), id: exception.id})
      })
      return exceptions
    })
    .catch(err => console.log(err))
}

export default {
  fetchErrors
}
